"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var st_1 = require("../../st");
var i_st_1 = require("../../st/interface/i$st");
var define_context_1 = require("../function/define-context");
var ContextTrait = /** @class */ (function () {
    function ContextTrait() {
    }
    ContextTrait.enableFor = function (instance) {
        var prototype = Object.getPrototypeOf(instance);
        // no @context used in target class
        if (!prototype[define_context_1.CONTEXT_ASSIGNMENTS])
            return;
        var _loop_1 = function (contextPropAssignment) {
            // instead of reading and writing from/to the class instance memory,
            // use the context cache instead
            Object.defineProperty(prototype, contextPropAssignment.propName, {
                get: function () {
                    return st_1.st[i_st_1.GlobalCache.CONTEXT][contextPropAssignment.contextName].value;
                },
                set: function (value) {
                    st_1.st[i_st_1.GlobalCache.CONTEXT][contextPropAssignment.contextName].value = value;
                },
                configurable: true,
            });
            // hook onContextChange lifecycle method
            st_1.st.context(contextPropAssignment.contextName, prototype[define_context_1.CONTEXT_ASSIGNMENTS][contextPropAssignment], instance.onContextChange.bind(instance), instance);
        };
        for (var _i = 0, _a = prototype[define_context_1.CONTEXT_ASSIGNMENTS]; _i < _a.length; _i++) {
            var contextPropAssignment = _a[_i];
            _loop_1(contextPropAssignment);
        }
    };
    return ContextTrait;
}());
exports.ContextTrait = ContextTrait;
//# sourceMappingURL=context.js.map